import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {CfiCompanyType} from "../types/CfiCompanyType";
import {CfiRoutingType} from "../types/CfiRoutingType";

export const useGetCfiRouting = (cfiId: number | null, companyId: number | undefined) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {data, isLoading, refetch} = useQuery({
        queryKey: ['get-cfi-routing', cfiId ?? 0, companyId ?? 0],
        queryFn: async () => await apiClient.get('cfi-routing?CompanyID=' + cfiId) as CfiRoutingType,
        enabled: ((cfiId ?? 0) > 0) && ((companyId ?? 0) > 0)
    });

    return {
        data,
        isLoading,
        refetch
    };
};
